import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Create,
  CreateProps,
  useTranslate,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  SaveButton,
  ListButton,
} from 'react-admin'
import { EntranceDto } from '../../../core/dto/entrance.dto'

const validateEntranceCreate = (values: EntranceDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.note) {
    errors.note = 'ra.validation.required'
  }
  return errors
}

const CreateTitle = () => {
  const translate = useTranslate()
  return <span>{translate('resources.entrances.titles.create')}</span>
}

const CreateToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ListButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const EntranceCreate = (props: CreateProps) => (
  <Create {...props} hasShow={false} title={<CreateTitle />}>
    <SimpleForm
      redirect="show"
      toolbar={<CreateToolbar />}
      validate={validateEntranceCreate}
    >
      <TextInput source="note" isRequired />
    </SimpleForm>
  </Create>
)
